import en from './en'

const language = {
    ENGLISH: 'English',
    BULGARIAN: 'Bulgarian',
    ROMANIAN: 'Română',
}

const country = {
    BULGARIA: 'Bulgaria',
    ROMANIA: 'Romania',
}

const navigation = {
    NAVIGATION_HOME: 'Home',
    NAVIGATION_TEAM: 'Team',
    NAVIGATION_STATISTICS: 'Statistici',
    NAVIGATION_SETTINGS: 'Settings',
    NAVIGATION_QR: 'QR-code',
    NAVIGATION_HELP: 'Ajutor',
}

const header = {
    HEADER_LOGOUT: 'Deconectare',
}

const months = {
    JANUARY: 'Ianuarie',
    FEBRUARY: 'Februarie',
    MARCH: 'Martie',
    APRIL: 'Aprilie',
    MAY: 'Mai',
    JUNE: 'Iunie',
    JULY: 'Iulie',
    AUGUST: 'August',
    SEPTEMBER: 'Septembrie',
    OCTOBER: 'Octombrie',
    NOVEMBER: 'Noiembrie',
    DECEMBER: 'Decembrie',
}

const shortMonths = {
    JAN: 'Ian',
    FEB: 'Feb',
    MAR: 'Mar',
    APR: 'Apr',
    MAY: 'Mai',
    JUN: 'Iun',
    JUL: 'Iul',
    AUG: 'Aug',
    SEP: 'Sep',
    OCT: 'Oct',
    NOV: 'Nov',
    DEC: 'Dec',
}

const auth = {
    AUTH_CASHLESS_TIPS: 'CASHLESS TIPS',
    AUTH_UP_TO_40: 'Cu până la 40% mai mult bacșiș în fiecare zi',
    AUTH_SIGNIN_OPTION: 'AUTENTIFICĂ-TE',
    AUTH_SIGNUP_OPTION: 'ÎNREGISTREAZĂ-TE',
    AUTH_SIGNIN_TITLE: 'Autentifică-te',
    AUTH_SIGNUP_TITLE: 'Înregistrează-te',
    AUTH_NAME: 'Nume',
    AUTH_NAME_PLACEHOLDER: 'Introduceți numele',
    AUTH_ORGANIZATION: 'Organizație',
    AUTH_ORGANIZATION_PLACEHOLDER: 'Introduceți numele organizației',
    AUTH_COUNTRY: 'Țară',
    AUTH_COUNTRY_PLACEHOLDER: 'Alegeți o tară din listă',
    AUTH_COUNTRY_PLACEHOLDER_SHORT: 'Alege o tară',
    AUTH_PHONE: 'Număr de telefon',
    AUTH_PHONE_PLACEHOLDER: 'Introduceți numărul de telefon',
    AUTH_EMAIL: 'E-mail',
    AUTH_EMAIL_PLACEHOLDER: 'Introduceți o adresă de e-mail',
    AUTH_PASSWORD: 'Parolă',
    AUTH_SIGNUP_PASSWORD_PLACEHOLDER: 'Alegeți o parolă',
    AUTH_SIGNIN_PASSWORD_PLACEHOLDER: 'Introduceți parola',
    AUTH_FORGOT_PASSWORD: 'Am uitat parola?',
    AUTH_SOCIAL: 'Vă rugăm să evaluați serviciile noastre',
    AUTH_STRIPE_TOS:
        'Folosim Stripe pentru a ne asigura că primiți banii la timp, în timp ce datele dumneavoastră personale și contul bancar sunt protejate.',
    AUTH_SELECT_LANGUAGE: 'Alege limba',
    AUTH_CANCEL_BUTTON: 'ANULEAZĂ',
    AUTH_SIGNIN_BUTTON: 'AUTENTIFICĂ-TE',
    AUTH_SIGNUP_BUTTON: 'ÎNREGISTREAZĂ-TE',
}

const onboarding = {
    ONBOARDING_STEP: 'Pas',
    ONBOARDING_STEP_REGISTRATION: 'Înregistrare',
    ONBOARDING_STEP_EMAIL: 'Confirmare email',
    ONBOARDING_STEP_STRIPE: 'Stripe',
    ONBOARDING_EMAIL_DESCRIPTION:
        'Ați primit un email ce conține codul de confirmare la adresa',
    ONBOARDING_ENTER_CODE: 'Introduceți codul de confirmare primit',
    ONBOARDING_SEND_CODE_AGAIN: 'Retrimite codul',
    ONBOARDING_INCORRECT_CODE: 'COD INCORECT',
    ONBOARDING_BACK: 'ÎNAPOI',
    ONBOARDING_STRIPE_DESCRIPTION:
        'PENTRU A CONECTA SISTEMUL DE PLATĂ, TREBUIE SĂ ÎȚI CREEZI UN CONT PE PLATFORMA STRIPE (PLATFORMĂ PENTRU PROCESARE PLĂȚI)',
    ONBOARDING_GO_TO_STRIPE: 'CĂTRE STRIPE',
    ONBOARDING_STRIPE_SUCCESS: 'CONT CREAT CU SUCCES',
    ONBOARDING_OK: 'OK',
}

const home = {
    HOME_CURRENT_MONTH: 'Tips în luna curentă',
    HOME_YEAR_TIPS: 'Tips în ultimul an',
    HOME_NPS: 'NPS',
    HOME_TOP_STAFF: 'Top staff',
    HOME_LAST_MONTH: 'last month',
    HOME_CASH_TIP: 'Cash tip',
    HOME_CASH_TIP_DESCRIPTION: 'Add cash tips to include in statistics',
    HOME_ADD_TIP_BUTTON: 'ADD TIP',
}

const qr = {
    QR_TITLE: 'CODUL QR',
    QR_DOWNLOAD: 'Descarcă',
    QR_POSM: 'POSM',
    QR_STICKER: 'Sticker',
    QR_CARD: 'Card',
    QR_TABLETOP: 'QR pentru masă',
    QR_STICKER_SIZE: 'Dimensiune recomandată\n pentru imprimare 80x80mm',
    QR_CARD_SIZE: 'Dimensiune recomandată\n pentru imprimare 80x80mm',
    QR_TABLETOP_SIZE: 'Dimensiune recomandată\n pentru imprimare 148x210mm',
    QR_TAB_ORGANIZATION: 'QR codul organizației',
    QR_TAB_EMPLOYEES: 'QR code angajați',
    QR_REMOVE_EMPLOYEE: 'Ștergeți angajatul?',
    QR_BUTTON_REMOVE: 'ȘTERGE',
    QR_BUTTON_CANCEL: 'ANULEAZĂ',

    QR_SORT_PLACEHOLDER: 'Sortează după',
    QR_SORT_BY_NAME: 'Nume',
    QR_SORT_RATING: 'Rating',
    QR_SORT_TIPS_AMOUNT: 'Valoare bacșiș',
    QR_SORT_EXPERIENCE: 'Experiență anterioară',
    QR_EMPLOYEE_MODAL_ROLE_PLACEHOLDER: 'Selectați din listă',
    QR_EMPLOYEE_MODAL_BIRTH_PLACEHOLDER_DAY: 'Zi',
    QR_EMPLOYEE_MODAL_BIRTH_PLACEHOLDER_MONTH: 'Lună',
    QR_EMPLOYEE_MODAL_BIRTH_PLACEHOLDER_YEAR: 'An',
    QR_EMPLOYEE_MODAL_REMOVE_EMPLOYEE: 'Șterge angajat',

    QR_EMPLOYEE_PHONE: 'Număr de telefon',
    QR_EMPLOYEE_EMAIL: 'E-mail',

    QR_EMPLOYEE_MODAL_FULL_NAME: 'Nume și Prenume',
    QR_EMPLOYEE_MODAL_FULL_NAME_PLACEHOLDER: 'Introduceți nume și prenume',
    QR_EMPLOYEE_MODAL_DATE_OF_BIRTH: 'Ziua de naștere',
    QR_EMPLOYEE_MODAL_DATE_OF_BIRTH_PLACEHOLDER: 'Introduceți ziua de naștere',
    QR_EMPLOYEE_MODAL_PHONE: 'Număr de telefon',
    QR_EMPLOYEE_MODAL_PHONE_PLACEHOLDER: 'Introduceți numărul de telefon',
    QR_EMPLOYEE_MODAL_EMAIL: 'E-mail',
    QR_EMPLOYEE_MODAL_EMAIL_PLACEHOLDER: 'Introduceți e-mail',
    QR_EMPLOYEE_MODAL_POSITION: 'Funcție',
    QR_EMPLOYEE_MODAL_POSITION_PLACEHOLDER: 'Selectați din listă',
    QR_EMPLOYEE_MODAL_ADD_NEW: 'Nou',
    QR_EMPLOYEE_MODAL_CANCEL_BUTTON: 'ANULEAZĂ',
    QR_EMPLOYEE_MODAL_SAVE_BUTTON: 'SALVEAZĂ',
}
const statistics = {
    STATISTICS_CURRENT_MONTH: 'Tipsului și Notă',
    STATISTICS_CURRENT_MONTH_RATING: 'Rating',
    STATISTICS_YEAR_TIPS: 'Tips în ultimul an',
    STATISTICS_EMPLOYEES_TABLE_TITLE: 'Tipsului per angajat',

    STATISTICS_EMPLOYEES_TABLE_NO: 'No',
    STATISTICS_EMPLOYEES_TABLE_AVATAR: '',
    STATISTICS_EMPLOYEES_TABLE_NAME: 'Nume',
    STATISTICS_EMPLOYEES_TABLE_ROLE: 'Rol',
    STATISTICS_EMPLOYEES_TABLE_RATING: 'Rating',
    STATISTICS_EMPLOYEES_TABLE_TIPS: 'Bacșiș',

    STATISTICS_FEES_DISCLAIMER: "Vă informăm că valorile afișate nu conțin taxe și comisioane.",
}

const errors = {
    ERROR_DEFAULT: 'Ceva nu a mers',
    ERROR_CODE_RESEND_WRONG_EMAIL: 'Adresă de email greșită',
    ERROR_CODE_RESEND_TOO_EARLY: 'Te rog să încerci mai târziu',
    ERROR_SESSION_EXPIRED: 'Sesiunea ta a expirat',
    ERROR_EMAIL_CODE_NOT_VALID: 'Codul nu este valid',
    ERROR_EMAIL_IS_ALREADY_USED: 'Email is already used',
    ERROR_EMAIL_WRONG_CREDENTIALS: 'Wrong email or password',
}

const validationErrors = {
    VALIDATION_TOO_SHORT: 'Prea scurtă',
    VALIDATION_TOO_LONG: 'Prea lungă',
    VALIDATION_INVALID_EMAIL: 'Adresă de email incorectă',
    VALIDATION_NO_SPACE: 'Spațiul nu este permis',
    VALIDATION_PHONE_FORMAT: 'Formatul numărului de telefon nu este corect',
}

const ro: Record<keyof typeof en, string> = {
    ...errors,
    ...validationErrors,
    ...language,
    ...country,
    ...months,
    ...shortMonths,
    ...header,

    ...onboarding,

    ...navigation,
    ...auth,
    ...home,
    ...qr,
    ...statistics,
} as const

export default ro
